var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 346H16V496H496V346Z",
    fill: "#F1C40F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 331H16V346H496V331Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 181H16V331H496V181Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V166H496V16Z",
    fill: "#16A085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 166H16V181H496V166Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L216 256.002L16 496V16Z",
    fill: "#CA4638"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.028 324.686L94.1929 292.593L50.4176 324.695L67.3947 273.089L23.3359 241.376L77.663 241.575L94.2085 189.873L110.807 241.603L165.092 241.361L121.023 273.133L138.028 324.686Z",
    fill: "#E5B731"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1479 288.699H87.7257C90.2664 291.549 95.9353 292.712 101.335 288.665C111.232 283.245 130.38 288.699 130.38 288.699L134.15 284.693L124.96 254.529L121.66 250.994C121.66 250.994 114.591 246.753 101.158 248.166C87.7257 249.58 83.0125 247.695 83.0125 247.695C83.0125 247.695 71.23 249.109 67.9307 250.758C67.568 251.052 64.1602 254.529 64.1602 254.529L56.1479 288.699Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 1.27506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5107 280.923C62.5107 280.923 92.6744 277.153 101.394 288.699C96.4697 292.069 92.134 292.347 87.4902 288.936C88.2299 287.703 98.3304 277.153 124.017 280.688",
    stroke: "#262626",
    strokeWidth: 1.27506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7956 250.759L94.5601 283.987L94.7956 250.759ZM121.66 251.23L127.316 277.623L121.66 251.23ZM68.2419 250.815L65.103 264.427Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2419 250.815L65.103 264.427M94.7956 250.759L94.5601 283.987L94.7956 250.759ZM121.66 251.23L127.316 277.623L121.66 251.23Z",
    stroke: "#262626",
    strokeWidth: 1.27506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6387 292.317L43.0649 301.024C43.937 301.544 44.7116 301.511 45.4862 301.024L56.4921 287.817L61.1146 282.094C61.8303 281.247 62.0588 280.301 61.995 279.453L70.8322 271.601C71.5551 271.65 71.9857 271.732 72.7086 271.781C71.8545 271.56 71.2278 271.144 71.9003 270.208L73.8812 268.667L75.4218 270.648C75.4218 270.648 73.221 273.51 73.0009 273.51C72.7808 273.51 70.5796 273.51 70.5796 273.51L65.9572 277.692L67.9779 279.478L71.0199 287.817L74.7621 285.176L72.3405 276.592L77.6237 270.868L75.6423 267.786L76.9632 266.025C76.9632 266.025 95.2469 277.537 102.291 274.455C102.481 274.524 102.717 266.246 102.717 266.246C102.717 266.246 83.7869 264.265 83.3461 260.523C82.906 256.781 87.5287 256.341 87.5287 256.341L85.5472 253.479L85.988 251.938L89.2897 256.12L96.7739 249.737L140.797 299.924C143.2 298.949 143.713 298.361 143.879 295.961C143.817 295.901 100.736 246.435 100.736 246.435L104.038 242.914C104.688 242.18 104.917 241.868 104.918 240.712L109.981 236.31C111.503 236.833 112.474 237.745 113.282 238.951L127.201 227.155C127.568 227.522 128.682 227.889 129.438 227.476L152.449 205.389L127.37 223.103L126.49 222.442C126.49 221.709 127.399 221.527 126.49 220.241C125.515 219.072 124.068 221.342 123.848 221.342C123.628 221.342 120.218 220.137 119.471 218.61L119.226 222.663L112.842 228.606L108 228.386L100.956 235.209L100.076 237.85L101.176 240.052C101.176 240.052 97.4337 243.354 97.4337 243.133C97.4337 242.914 96.6773 242.16 96.6448 242.063L99.8552 239.171L100.295 237.19L99.2241 235.518C98.8995 235.754 94.7925 240.052 94.5721 239.611C94.2052 239.201 82.6864 226.184 82.6864 226.184L83.3461 223.763L75.8627 215.619C73.1343 214.677 68.8187 214.518 67.9382 220.461C67.2526 221.857 61.5548 220.681 61.5548 220.681L58.4732 221.342L41.0838 245.995L50.769 257.661L70.5796 232.568L71.1677 225.459L75.3245 230.107C76.7103 230.285 78.0306 230.3 79.2866 229.667L91.0236 242.767L89.0693 244.674C89.7298 245.408 90.1842 245.876 90.8447 246.61C91.5052 246.17 92.1354 245.642 92.7959 245.201C93.0163 245.495 93.3832 246.053 93.6036 246.347C92.62 246.882 91.9301 247.594 90.9466 248.13C89.3727 247.104 87.8532 245.827 87.9687 243.794L81.3654 249.297L81.145 250.397L61.5548 266.686L59.7938 266.906L59.3536 271.969L72.1204 261.403V259.862L73.4411 260.963L83.3461 253.039C83.3461 253.039 84.0066 253.919 83.7869 253.919C83.5665 253.919 74.9818 261.844 74.9818 261.844L74.7621 262.724L73.221 264.045L72.3405 263.384L60.4542 273.95H58.6933L52.0897 280.554C50.3865 280.702 48.9107 280.882 47.4673 281.874L35.6387 292.317Z",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 1.27506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/MZ.31b0ef6b1a1778fa5c3341fcc4fc6c06.svg";
export { ForwardRef as ReactComponent };